import ShopsPage from "./ShopsPage";

export default function ShopsCoveragePage() {
  return <ShopsPage view="coverage" />;
}
